import { useNotification } from '@/hooks';
import { useCreateBrandMutation, useUpdateBrandMutation } from '../../service';
import { BrandSchema } from '../models';
import { NotificationSeverity } from '@/components/notifications/Notification';

const useBrandsActions = () => {
  const [createBrand, { isLoading: isCreatingBrand }] = useCreateBrandMutation();
  const [updateBrand, { isLoading: isUpdatingBrand }] = useUpdateBrandMutation();

  const { showNotification } = useNotification();

  const onCreateBrand = async (data: BrandSchema, reset: () => void) => {
    try {
      const result = await createBrand({ name: data.name }).unwrap();
      showNotification(
        'Marca creada correctamente',
        NotificationSeverity.success
      );
      reset();
      return result;
    } catch (error: any) {
      console.error('Error creating brand:', error);
      showNotification(
        'Ocurrió un error al crear la marca. Inténtalo nuevamente.',
        NotificationSeverity.error
      );
      throw error;
    }
  };

  const onUpdateBrand = async (
    brandId: string,
    data: BrandSchema,
    reset: () => void
  ) => {
    try {
      await updateBrand({ brandId, body: { name: data.name } }).unwrap();
      showNotification(
        'Marca actualizada correctamente',
        NotificationSeverity.success
      );
      reset();
    } catch (error: any) {
      console.error('Error updating brand:', error);
      showNotification(
        'Ocurrió un error al actualizar la marca. Inténtalo nuevamente.',
        NotificationSeverity.error
      );
    }
  };

  return {
    isCreatingBrand,
    isUpdatingBrand,
    onCreateBrand,
    onUpdateBrand,
  };
};

export default useBrandsActions; 